<template>
	<ModelForm
		:modelId="modelId"
		resource="sales-channel-contacts"
		:modelInfo="defaultModelInfo"
		v-slot="slotProps"
		:successCallback="successCallback"
		ref="form"
	>
		<b-form-row>
			<b-form-group :disabled="unableEdit" class="col-4" label="Nombre">
				<b-form-input type="text" size="sm" v-model="slotProps.modelInfo.firstName" required />
			</b-form-group>
			<b-form-group :disabled="unableEdit" class="col-4" label="Apellido">
				<b-form-input type="text" size="sm" v-model="slotProps.modelInfo.lastName" required />
			</b-form-group>
			<b-form-group :disabled="unableEdit" class="col-4" label="Genera notificación de cambio">
				<b-form-checkbox size="sm" v-model="slotProps.modelInfo.recievesUpdateNotification" />
			</b-form-group>
		</b-form-row>
		<b-form-row>
			<b-form-group :disabled="unableEdit" class="col-3" label="Teléfono">
				<b-form-input type="tel" size="sm" v-model="slotProps.modelInfo.phone" />
			</b-form-group>
			<b-form-group :disabled="unableEdit" class="col-3" label="Email">
				<b-form-input type="email" size="sm" v-model="slotProps.modelInfo.email" />
			</b-form-group>
			<b-form-group :disabled="unableEdit" class="col-3" label="Departamento">
				<b-form-input type="text" size="sm" v-model="slotProps.modelInfo.department" />
			</b-form-group>
			<b-form-group :disabled="unableEdit" class="col-3" label="Descripción">
				<b-form-input type="text" size="sm" v-model="slotProps.modelInfo.Descripción" />
			</b-form-group>
		</b-form-row>
		<hr>
		<div class="text-right">
			<b-button :disabled="unableEdit" variant="primary" type="submit">{{modelId>0?'Actualizar':'Guardar'}}</b-button>
		</div>
	</ModelForm>
</template>

<script>
import ModelForm from '../../helpers/ModelForm.vue'

export default {
	props: {
		unableEdit: Boolean,
		modelId: {
			type : Number,
			required: false,
			default:-1
		},
		salesChannelId: {
			type : Number,
			required: false,
			default:-1
		},
		modalId: {
			type : String,
			required: true,
		},
	},
	components: { ModelForm },
	data(){
		return {
			loading:true,
			defaultModelInfo:{
				id:-1,
				firstName:'',
				lastName:'',
				phone:'',
				email:'',
				recievesUpdateNotification: false,
				salesChannelId:this.salesChannelId,
			},
		}
	},
	computed: {

	},
	methods:{
		successCallback(){
			if(this.modelId<=0) this.$root.$emit('bv::hide::modal', this.modalId , null)
		}
	},
	watch: {
		salesChannelId: function () {
			this.defaultModelInfo.salesChannelId = this.salesChannelId;
			this.$refs.form.modelInfoReal.salesChannelId = this.salesChannelId
		}
	}
}
</script>

<style>

</style>
